import { inject } from '@angular/core';
import { APPLY_CHANGE_STATE_MUTATION } from '@core/devices/state/device.tokens';

export const injectApplyChangeStateMutation = () => inject(APPLY_CHANGE_STATE_MUTATION);
